/* Marketplace search and sorting. Normal GET forms remain usable without JS. */
(() => {
  document.documentElement.classList.add('bz-js');
  const root = window.Shopify?.routes?.root || '/';
  const initialized = new WeakSet();
  const headerObservers = new WeakMap();
  document.addEventListener('change', event => {
    if (event.target.matches('[data-market-sort]')) event.target.form.requestSubmit();
  });
  function init(scope = document) {
    scope.querySelectorAll('[data-market-header]').forEach(header => {
      if (headerObservers.has(header)) return;
      const container = header.closest('.shopify-section') || header;
      const update = () => document.documentElement.style.setProperty('--bz-header-offset', `${Math.ceil(container.getBoundingClientRect().height)}px`);
      if ('ResizeObserver' in window) {
        const observer = new ResizeObserver(update);
        observer.observe(container);
        headerObservers.set(header, observer);
      }
      update();
    });
    scope.querySelectorAll('[data-market-search]').forEach(form => {
      if (initialized.has(form)) return;
      initialized.add(form);
      const input = form.querySelector('[data-market-input]');
      const results = form.querySelector('[data-market-results]');
      let timer, controller, generation = 0;
      const hide = () => { results.hidden = true; input.setAttribute('aria-expanded', 'false'); };
      const show = () => { results.hidden = false; input.setAttribute('aria-expanded', 'true'); };
      input.addEventListener('input', () => {
        clearTimeout(timer); controller?.abort(); generation++;
        const term = input.value.trim(); const version = generation;
        results.replaceChildren(); hide();
        if (term.length < 2) return;
        timer = setTimeout(async () => {
          controller = new AbortController();
          const signal = controller.signal;
          results.setAttribute('aria-busy', 'true');
          const loading = document.createElement('p'); loading.className = 'bz-search-loading'; loading.textContent = 'Looking for your next box…'; results.replaceChildren(loading); show();
          try {
            const url = root + 'search/suggest?section_id=predictive-search&resources[type]=product&resources[limit]=6&q=' + encodeURIComponent(term);
            const response = await fetch(url, { signal });
            if (!response.ok) throw new Error('Search unavailable');
            const html = await response.text();
            if (version !== generation || input.value.trim() !== term || !form.isConnected) return;
            const section = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
            results.innerHTML = section?.innerHTML || '';
            if (form.contains(document.activeElement)) show(); else hide();
          } catch (error) {
            if (error.name === 'AbortError' || version !== generation) return;
            const fallback = document.createElement('a'); fallback.className = 'text-link'; fallback.href = root + 'search?type=product&q=' + encodeURIComponent(term); fallback.textContent = 'View all matching products →'; results.replaceChildren(fallback);
          } finally { if (version === generation) results.removeAttribute('aria-busy'); }
        }, 220);
      });
      input.addEventListener('focus', () => { if (input.value.trim().length > 1 && results.childElementCount) show(); });
      form.addEventListener('keydown', event => {
        if (event.key === 'Escape') { generation++; clearTimeout(timer); controller?.abort(); input.focus(); hide(); results.removeAttribute('aria-busy'); }
        if (event.key === 'ArrowDown' && event.target === input && !results.hidden) { const first = results.querySelector('a'); if (first) { event.preventDefault(); first.focus(); } }
      });
      form.addEventListener('focusout', () => { queueMicrotask(() => { if (!form.contains(document.activeElement)) hide(); }); });
      document.addEventListener('pointerdown', event => { if (!form.contains(event.target)) hide(); });
    });
  }
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-market-header]').forEach(header => headerObservers.get(header)?.disconnect()));
  init();
})();
